import types from "../actions/actionTypes";
import initialState from "./initialState";

const showCompleteProjectsReducer = (state = initialState.showCompleteProjects, action) => {

    
    switch (action.type) {
        case types.TOGGLE_SHOW_COMPLETE_PROJECTS:
            return !state;     
        default:
            return state;
    }
}

export default showCompleteProjectsReducer;